// 這邊專門放全域變數
import $ from 'jquery';
import Config from './config';
import { canCashOut } from './api';
import axios from 'axios';
import { getFullUrlPath } from '../utils/common';

const SITE_NAME = Config.appConfig.SiteName;
window.switchViewSkinType = ('webskintype').toLowerCase();
window.setCurrMainTab = ('scmt').toLowerCase();
window.setShowMainTab = ('ssmt').toLowerCase();
window.setSportsTab = '';
window.SITE_MODE = 'NewIndex';

if(Config.appConfig.EnableCookielessCheckFinger) {
	if(fingerprintCreator) {
		fingerprintCreator.makeVisitorId().then(res => {
			if (res.status === 'ok') {
				console.log(res.visitorId);
				axios.post(getFullUrlPath('NewIndex/SetFingerprint'), { visitorId : res.visitorId }).then(result => {
					if(result.data){
						//console.log("result.data.status = " + result.data.status);
						//console.log("result.data.redirectURL = " + result.data.redirectURL);
						if(result.data.status === 2) {
							location.href = result.data.redirectURL;
						}
					}
					else {
						//console.log("result.data is null");
					}
				});
			} else {
				// Failure
				console.log(res.message);
			}
		});
	}
	
}

window.ReceiveCallback = function(key) {
	let _key = key;
	try {
		while(_key.data.data != undefined){
			_key = _key.data;
		}
	}
	catch {

	}
	//alert("parent logout");
	if (key == 'logout' || key.data=="logout") {
		window.location.href = 'logout.aspx';
	}

	else if (key.data == 'ToOldView') {
		$('#clickBtnBySkinType', window.document).trigger('click', [{ key: '0' }]);
	}

	else if (key.data == 'ToEuroView') {
		$('#clickBtnBySkinType', window.document).trigger('click', [{ key: '1' }]);
	}

	else if (key == 'ToSingBetView' || key.data == 'ToSingBetView' || _key.data == 'ToSingBetView') {
		$('#clickBtnBySkinType', window.document).trigger('click', [{ key: '2' }]);
	}

	else if (key == 'ToNewView' || key.data == 'ToNewView' || _key.data == 'ToNewView') {
		$('#clickBtnBySkinType', window.document).trigger('click', [{ key: '3' }]);
	}

	else if (key == 'ToGalaxyView' || key.data == 'ToGalaxyView' || _key.data == 'ToGalaxyView') {
		$('#clickBtnBySkinType', window.document).trigger('click', [{ 
			key: '7',
			sportId : key.data.sportId,
			types : key.data.types? key.data.types : null,
			leagueId : key.data.leagueId ? key.data.leagueId : null,
		}]);
	}
	else if (key == 'ToMarsView' || key.data == 'ToMarsView' || _key.data == 'ToMarsView') {
		$('#clickBtnBySkinType', window.document).trigger('click', [{ 
			key: '8',
			sportId : key.data.sportId,
			types : key.data.types? key.data.types : null,
			leagueId : key.data.leagueId ? key.data.leagueId : null,
		}]);
	}
	else if (key == 'openBonusPromotion' || key.data == 'openBonusPromotion' || _key.data == 'openBonusPromotion') {
		const bonusCode = key.href || _key.href;
		$('#clickBtnByOpenBonus', window.document).trigger('click', [{ key: '0', data: bonusCode }]);
	}
	
	else if (key == 'openPromotion' || key.data == 'openPromotion' || _key.data == 'openPromotion') {
		$('#clickBtnByOpenBonus', window.document).trigger('click', [{ key: '1' }]);
	}
	
	else if (key == 'openSabaLoyalty' || key.data == 'openSabaLoyalty' || _key.data == 'openSabaLoyalty') {
		const planid = key.href || _key.href;
		$('#clickBtnByOpenBonus', window.document).trigger('click', [{ key: '2', data: planid  }]);
	}
	
	else if (key == 'openSabaLoyaltyExchange' || key.data == 'openSabaLoyaltyExchange' || _key.data == 'openSabaLoyaltyExchange') {
		const planid = key.href || _key.href;
		$('#clickBtnByOpenBonus', window.document).trigger('click', [{ key: '3', data: planid  }]);
	}

	else if (key == 'openSabaClubFreeBet' || key.data == 'openSabaClubFreeBet' || _key.data == 'openSabaClubFreeBet') {
		$('#clickBtnByOpenBonus', window.document).trigger('click', [{ key: '4'}]);
	}

	else if (key == 'openEuroCupOddsBoost' || key.data == 'openEuroCupOddsBoost' || _key.data == 'openEuroCupOddsBoost') {
		$('#clickBtnByOpenBonus', window.document).trigger('click', [{ key: '5'}]);
	}

	else if (key == 'openSabaClub' || key.data == 'openSabaClub' || _key.data == 'openSabaClub') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "sabaclub", para2: key.data}]);
	}
	
	else if (key == 'openVGaming' || key.data == 'openVGaming' || _key.data == 'openVGaming') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "vgaming", para2: key.data}]);
	}
	
	else if (key == 'openVGamingMobi' || key.data == 'openVGamingMobi' || _key.data == 'openVGamingMobi') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "vgaming", para1: true, para2: key.data}]);
	}

	else if (key == 'openAdvantPlayVendorLobby' || key.data == 'openAdvantPlayVendorLobby' || _key.data == 'openAdvantPlayVendorLobby') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "advantplay", para2: key.data}]);
	}

	else if (key == 'openVirtualGame' || key.data == 'openVirtualGame' || _key.data == 'openVirtualGame') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "virtualgame", para2: key.data}]);
	}

	
	else if (key == 'openLeapGaming' || key.data == 'openVirtuopenLeapGamingalGame' || _key.data == 'openLeapGaming') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "leapgaming", para2: key.data}]);
	}
	
	else if (key == 'openMaxGame' || key.data == 'openMaxGame' || _key.data == 'openMaxGame') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "maxgame", para2: key.data}]);
	}

	else if (key == 'openLucky3D' || key.data == 'openLucky3D' || _key.data == 'openLucky3D') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "lucky3d", para2: key.data}]);
	}

	else if (key.data.behavior == 'openNSLottery'){
		var usertimezone = new Date().getTimezoneOffset() / -60;
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "nslottery", para1: usertimezone, para2: key.data}]);
	}

	else if (key.data.behavior == 'openVirtualGame'){
		var usertimezone = new Date().getTimezoneOffset() / -60;
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "virtualgame", para1: usertimezone, para2: key.data}]);
	}

	else if (key.data == 'stopAutoLoginCheckIn') {
		$('#clickBtnByStopLoginCheckin', window.document).trigger('click', [{ key: '0' }]);
	}

	else if (key.data == 'openSignUp' || (key.data && key.data.key == 'openSignUp') ) {
		if (key.data && key.data.url) {
			$('#clickBtnByPopupType', window.document).trigger('click', [{ key: 0, para1: 'SingUpByOpenSports', para2: key.data.url}]);
		} else {
			let bonusCode = '';
			if (key.data && key.data.bonusCode) {
				bonusCode = key.data.bonusCode;
			}
			$('#clickBtnByPopupType', window.document).trigger('click', [{ key: 0 , para1: bonusCode}]);
		}
	}

	else if (key.data == 'openLogin' || (key.data && key.data.key == 'openLogin')) {
		if (key.data && key.data.url) {
			$('#clickBtnByPopupType', window.document).trigger('click', [{ key: 2, para1: 'loginByOpenSports', para2: key.data.url}]);
		} else {
			$('#clickBtnByPopupType', window.document).trigger('click', [{ key: 2 }]);
		}
	}
	
	else if (key.data == 'openDeposit') {
		$('#clickBtnByOpenDeposit', window.document).trigger('click', [{ key: '0' }]);
	}

	else if (key.data == 'canCashOut') {
		return canCashOut();
	}

	else if (key.data == 'ChangeLanguage') {
		$('#clickBtnByChangeLanguage', window.document).trigger('click', [{ key: key.Lang }]);
	}
	
	else if (_key.data == 'PopupNewIndexDiv') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: _key.type }]);
	}
	else if (key.data === 'Lic2Ready') {
		console.log("Lic2Ready received , key.data = " + key.data);	
		if(window.readyTimeoutID) {			
			console.log("clear readyTimeoutID");
			this.clearTimeout(window.readyTimeoutID);
			window.readyTimeoutID = null;			
		}
		var mainDiv = document.getElementById("athenaMainContainer"); 
		var newDiv = document.createElement("div")
		newDiv.setAttribute("id", "Div10000"); 
		document.body.insertBefore(newDiv, mainDiv.nextSibling);
	}
	else if(key == 'SwitchLine' || key.data === 'SwitchLine' || _key.data == 'SwitchLine'){
		window.changeNetwork(Config.appConfig.ActStatus, Config.appConfig.NetworkTotalLines, _key.line);
	}

	else if (key == 'deeplink' || key.data == 'deeplink' || _key.data == 'deeplink') {
		$('#clickBtnByDeepLink', window.document).trigger('click', [{ act: _key.act }]);
	}
	
	else if (key == 'openStatement' || key.data == 'openStatement' || _key.data == 'openStatement') {
		$('#clickBtnByOpenDeposit', window.document).trigger('click', [{ key: _key.type }]);
	}
	
	else if (key == 'openESportsWeb' || key.data == 'openESportsWeb' || _key.data == 'openESportsWeb') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "esports" }]);
	}
	
	else if (key == 'openEGamer' || key.data == 'openEGamer' || _key.data == 'openEGamer') {
		$('#clickBtnByPopupType', window.document).trigger('click', [{ key: "egamer", para1: _key.matchid, para2: _key.url}]);
	}
	
	else if (key == 'changeOddsType' || key.data == 'changeOddsType' || _key.data == 'changeOddsType') {
		const oddsType = key.href || _key.href;
		$('#clickBtnByChangeOddsType', window.document).trigger('click', [{ oddsType: oddsType }]);
	}

	else if (key == 'changeDarkmode' || key.data == 'changeDarkmode' || _key.data == 'changeDarkmode') {
		const isDarkMode = key.isDarkMode || _key.isDarkMode;
		$('#clickBtnByChangeDarkmode', window.document).trigger('click', [{ isDarkMode: isDarkMode }]);
	}
	
	else if (key == 'switchWebSkinType' || key.data == 'switchWebSkinType' || _key.data == 'switchWebSkinType') {
		const webSkinType = key.href || _key.href;
		const url = window.location.href;

		if (window.history.pushState) {
			let newQueryString = "";
			let tmpArray = url.split("?");
			const baseURL = tmpArray[0];
			const queryString = tmpArray[1];
			if (queryString) {
				tmpArray = queryString.split("&");
				tmpArray.forEach(query => {
					if (query.split('=')[0].toLowerCase() != "webskintype") {
						newQueryString += query + "&";
					}
				});
			}

			newQueryString += "webskintype=" + webSkinType;
			const newUrl = baseURL + "?" + newQueryString;
			window.history.pushState({ path: newUrl }, '', newUrl);

			axios.post(getFullUrlPath('NewIndex/SetWebSkinType'), { webSkinType });
        }
	}
	else if (key == 'openKeno' || key.data == 'openKeno' || _key.data == 'openKeno') {
		$('#clickBtnByOpenKeno', window.document).trigger('click');
	}
	else if (key == 'openKenoLotterty' || key.data == 'openKenoLotterty' || _key.data == 'openKenoLotterty') {
		$('#clickBtnByOpenKenoLotterty', window.document).trigger('click');
	}
	else if (key == 'openKenoTableGame' || key.data == 'openKenoTableGame' || _key.data == 'openKenoTableGame') {
		$('#clickBtnByOpenKenoTableGame', window.document).trigger('click');
	}
};

if (window.addEventListener) {
	window.addEventListener('message', window.ReceiveCallback, false);
} else if (window.attachEvent) {
	window.attachEvent('onmessage', window.ReceiveCallback);
}
